"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Input_1 = require("../../components/Input");
const form_1 = require("../form");
const __1 = require("../");
const useStatusHandler_1 = __importDefault(require("./useStatusHandler"));
const useSubmitHandler = ({ formDataType = 'object', onSubmit, onSuccess, }) => {
    const dispatch = (0, __1.useAppDispatch)();
    const changeStatus = (0, useStatusHandler_1.default)();
    const initialData = (0, __1.useAppSelector)(state => state.initialData);
    const changedData = (0, __1.useAppSelector)(state => state.changedData);
    const fields = (0, __1.useAppSelector)(state => state.fields);
    return (ev) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b;
        if (ev.preventDefault)
            ev.preventDefault();
        // since the form was submitting, change the status to pending and reset errors
        changeStatus('PENDING');
        dispatch((0, form_1.setErrors)([]));
        try {
            const form = ev.target;
            const valid = form.checkValidity();
            // if the form is invalid, set error status
            if (!valid) {
                changeStatus('ERROR');
                dispatch((0, form_1.setErrors)(['There are items that require your attention']));
                [
                    ...form.querySelectorAll(':invalid'),
                ].forEach(input => {
                    (0, Input_1.checkValidity)({ target: input });
                });
                return;
            }
            // get the form data
            const formData = new FormData(form);
            let data;
            if (fields && Object.keys(fields).length) {
                data = fields;
            }
            else {
                data =
                    formDataType === 'object' ? Object.fromEntries(formData) : formData;
            }
            // get the data that is changed
            const changed = JSON.parse(JSON.stringify(changedData || {}));
            // reset the the changed, so we continue to capture while submiting
            dispatch((0, form_1.resetChanged)());
            // submit the data
            const info = yield onSubmit(JSON.parse(JSON.stringify(data || {})), JSON.parse(JSON.stringify(initialData || {})), changed);
            // set the status to success
            changeStatus('SUCCESS');
            // reset after getting data
            if (info)
                dispatch((0, form_1.update)(info));
            // hide success and clear form
            setTimeout(() => __awaiter(void 0, void 0, void 0, function* () {
                if (onSuccess)
                    yield onSuccess(info, form);
                form
                    .querySelectorAll('[aria-invalid]')
                    .forEach((el) => el.removeAttribute('aria-invalid'));
            }), 1000);
        }
        catch (e) {
            if ((_b = (_a = e === null || e === void 0 ? void 0 : e.response) === null || _a === void 0 ? void 0 : _a.errors) === null || _b === void 0 ? void 0 : _b.length) {
                const errors = e.response.errors
                    .map((err) => err.extensions.code === 'INTERNAL_SERVER_ERROR'
                    ? 'Something has gone wrong, please try again.'
                    : err.message)
                    .filter(Boolean);
                dispatch((0, form_1.setErrors)(errors));
            }
            else {
                dispatch((0, form_1.setErrors)(['Something has gone wrong, please try again.']));
            }
            console.log('e', e);
            changeStatus('ERROR');
        }
    });
};
exports.default = useSubmitHandler;
